import type { LookupColumnDef } from "../../../../../_ovlclient/src/library/forms/sysformelement"
import {
  ListDefinition,
  SYSTableDef,
} from "../../../../../_ovlclient/src/library/table/table"
import type { FileList } from "../parts/filelist/filelist"

import { tblSearchPaket } from "../features/datdocuments/searchpaket/tabledef"
import { tblPackagingSplit } from "../features/pkgpackaging/packaging/packagingsplit/tabledef"
import { tblPackaging } from "../features/pkgpackaging/packaging/tabledef"
import { tblAdminUpload } from "../features/qutoffering/offering/adminupload/tabledef"
import {
  tblOfferingCosts,
  tblOfferingMaterial,
  tblOfferingTransport,
} from "../features/qutoffering/offering/details/tabledefs"
import { tblOffering } from "../features/qutoffering/offering/tabledef"
import { tblOfferingSettingsDef } from "../features/qutoffering/offeringsettings/tabledef"
import { tblSymbolPC } from "../features/spcsymbolpc/tabledef"
import { tblSymbolPCEndUser } from "../features/spcsymbolpc/tabledefenduser"
import { tblOfferingPos } from "../features/qutoffering/offering/cut/poslist/tabledef"
import { SortGet } from "../../../../../_ovlclient/src/global/globalapi"

export type Language = "DE" | "FR"

export type PicsState = {
  salesContact: string
}

export type PartnerState = {
  mainAttachments: FileList
  partnerAttachments: FileList
  salesContact: {
    id: string
    firstName: string
    lastName: string
    phone: string
    email: string
  }
}

type Role = "User" | "Admin"

type User = {
  offeringCadAttr: string
  offeringCadUserField: number
  offeringCadVal: string
  offeringDummyMaterialItemCode: string
}

let partner: PartnerState
let pics: PicsState = {
  salesContact: "",
}

let weekAndDate: ListDefinition

type RawB1LookupType = {
  TableId: string
  FieldId: string
  Key: string
  Value: string
}

let b1Lookups: Array<RawB1LookupType> = []

let user: User = {
  offeringCadAttr: undefined,
  offeringCadUserField: undefined,
  offeringCadVal: undefined,
  offeringDummyMaterialItemCode: undefined,
}

let tblOfferingActual: SYSTableDef = JSON.parse(JSON.stringify(tblOffering))
tblOfferingActual.id = "QUTOfferingActual"

let GEN = {
  user,
  pics,
  lookups: {
    weekAndDate,
    OCRD: {
      data: {},
      lookupDef: {
        CardCode: <LookupColumnDef>{
          mapToColumn: "U_CardCode",
          type: "text",
          translationKey: "SYSUserAdministrationColCardCode",
        },
        CardName: <LookupColumnDef>{
          type: "text",
          translationKey: "SYSUserAdministrationColCardName",
        },
      },
    },
  },
  lists: { b1Lookups },
}

let SPC = {
  tables: {
    SPCSymbolPC: {
      tableDef: {
        SPCSymbolPC: tblSymbolPC,
        SPCSymbolPCEndUser: tblSymbolPCEndUser,
      },
    },
  },
}

let PKG = {
  tables: {
    PKGPackaging: {
      data: undefined,
      tableDef: {
        PKGPackaging: tblPackaging,
      },
    },
    PKGPackagingSplit: {
      tableDef: {
        PKGPackagingSplit: tblPackagingSplit,
      },
    },
  },
}

let DAT = {
  tables: {
    DATSearchPaket: {
      data: undefined,
      tableDef: {
        DATSearchPaket: tblSearchPaket,
      },
    },
  },
  partner,
  counts: {
    invoiceCount: 0,
    quotationCount: 0,
    orderCount: 0,
  },
}
let QUT = {
  offering: {
    offeringSawCutSize: 0,
    offeringInitialCutSize: 0,
  },
  lookups: {
    CntctCode: {
      data: {},
      lookupDef: {
        CntctCode: <LookupColumnDef>{ type: "int" },
        CntctName: <LookupColumnDef>{ type: "text" },
        CardCode: <LookupColumnDef>{ type: "text" },
      },
    },
    U_ImportSKL: {
      data: {},
      lookupDef: {
        Code: <LookupColumnDef>{ type: "text" },
      },
    },
  },
  tables: {
    QUTOffering: {
      data: undefined,
      index: undefined,
      tableDef: {
        QUTOffering: tblOffering,
        QUTOfferingActual: tblOfferingActual,
      },
    },
    QUTOfferingPos: {
      data: undefined,
      index: undefined,
      tableDef: {
        QUTOfferingPos: tblOfferingPos,
      },
    },

    QUTOfferingCosts: {
      data: undefined,
      tableDef: {
        QUTOfferingCosts: tblOfferingCosts,
      },
    },
    QUTOfferingMaterial: {
      data: undefined,
      tableDef: {
        QUTOfferingMaterial: tblOfferingMaterial,
      },
    },
    QUTOfferingTransport: {
      data: undefined,
      tableDef: {
        QUTOfferingTransport: tblOfferingTransport,
      },
    },
    QUTOfferingSettings: {
      data: undefined,
      tableDef: {
        QUTOfferingSettings: tblOfferingSettingsDef,
      },
    },
    QUTOfferingAdminUpload: {
      tableDef: {
        QUTOfferingAdminUpload: tblAdminUpload,
      },
    },
  },
}

export let global = {
  DAT,
  SPC,
  PKG,
  QUT,
  GEN,
}
